import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-file-pdf"></i>',
                title: 'PDF megtekintése',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeDetails'
            },
        ],
        searchFields: [
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 3,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctorForEesztReport,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "doctorEesztUsername",
                label: "EESZT felhasználónév",
                formType: "text",
                formSize: 3
            },
            {
                name: "companySiteId",
                label: "Ellátóhely",
                visibility: false,
                formType: "select",
                formSize: 3,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "organizationUnitId",
                label: "Szervezeti egység",
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.findAllOrganizationUnit,
                    formatText: function (val) {
                        return val.companyName;
                    },
                    formatOption: function (val) {
                        return val.companyName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'companyName',
                    returnValue: 'organizationUnitId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                // formRequired: true,
                formVisible: true
            },
            {
                name: "appointmentDateFrom",
                label: "Vizsgálat időpontjától",
                formSize: 3,
                formType: "date"
            },
            {
                name: "appointmentDateTo",
                label: "Vizsgálat időpontjáig",
                formSize: 3,
                formType: "date"
            },
            {
                name: "patientName",
                label: "Páciens",
                formType: "text",
                formSize: 3
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ szám",
                formType: "text",
                formSize: 3
            },
            {
                name: "operatorEesztUsername",
                label: "Beküldő EESZT user",
                formType: "text",
                formSize: 3
            },
            {
                name: "startTimeFrom",
                label: "Felküldési időpontjától",
                formSize: 3,
                formType: "date"
            },
            {
                name: "startTimeTo",
                label: "Felküldési időpontjáig",
                formSize: 3,
                formType: "date"
            },
            {
                name: "isSuccesful",
                label: "Lefutás",
                formSize: 3,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [
                        {
                            id: "1",
                            text: 'Sikeres',
                            succesBoolean: 'true',
                        },
                        {
                            id: "2",
                            text: 'Sikertelen',
                            succesBoolean: 'false',
                        }
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'succesBoolean',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
        ],
        headerFields: [
            {
                name: "doctorName",
                label: "Orvos",
                visibility: true,
                sort: true
            },
            {
                name: "doctorEesztUsername",
                label: "EESZT felhasználónév",
                visibility: true,
            },
            {
                name: "siteName",
                label: "Ellátóhely",
                visibility: true,
            },
            {
                name: "organizationUnitName",
                label: "Szervezeti egység",
                visibility: true,
            },
            {
                name: "appointmentDate",
                label: "Vizsgálat időpontja",
                visibility: true,
                slot_name: "appointment_format",
            },
            {
                name: "patientName",
                label: "Páciens neve",
                visibility: true,
                sort: true
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                formType: "text",
                formSize: 3
            },
            {
                name: "operatorEesztUsername",
                label: "Beküldő EESZT user",
                visibility: true,
            },
            {
                name: "startTime",
                label: "Felküldési időpontja",
                visibility: true,
                sort: true,
                slot_name: "created_on_format"
            },
            {
                name: "isSuccesful",
                label: "Lefutás",
                visibility: true,
                slot_name: "success_format",
            },
            {
                name: "errorMessage",
                label: "Hiba",
                sort: true,
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
            }
        ]
    }
}
